import { CategoryMealType } from 'models/meal.model';
import React from 'react';
import { formatNumber } from 'utils/functions';

type Props = {
  meal: CategoryMealType;
  isBrandOpen: boolean;
  onClick: (id: string) => void;
};

const MealCategoryCard = ({ meal, isBrandOpen, onClick }: Props) => {
  const isSoldOut = meal.active && meal.available_no === '0';
  const isDisabled = isSoldOut || !isBrandOpen;

  return (
    <button
      onClick={() => onClick(meal.id)}
      key={meal.id}
      disabled={isDisabled}
      className='border border-[#EAEBEB] p-2 rounded-md'>
      <h4 className={`font-medium  ${isDisabled ? 'text-gray-4' : 'text-[#1A1A1A]'}`}>
        {meal.name}
      </h4>
      <p className='text-sm  text-[#858585]'>{formatNumber(meal.amount)}</p>
    </button>
  );
};

export default MealCategoryCard;
